<template>
  <div>
    permission page
  </div>
</template>

<script>
export default {
  name: 'permission'
}
</script>

<style lang="stylus" scoped>

</style>
